import { Button, Card, Intent } from '@blueprintjs/core';
import { SortOrder } from '@retro-ui/api-contract';

import Select from '@f/components/shared/select/Select';

import cls from './Filter.module.css';

export type SortingElement = [string | null, SortOrder | null];

interface Attribute {
  field: string;
  label: string;
  icon?: string;
}

interface SortingCardProps {
  attributes: Attribute[];
  label: string;
  onChange: (sorting: SortingElement[]) => void;
  sorting: SortingElement[];
  className?: string;
}
export function SortingCard(props: SortingCardProps) {
  const { className, attributes, label, onChange, sorting } = props;

  const onSortingAdd = () => {
    onChange([...sorting, [null, 'asc']]);
  };

  const onSortingRemove = (index: number) => {
    const newSorting = sorting.filter((_, i) => i !== index);
    onChange(newSorting);
  };

  const onAttributeChange = (index: number, attribute: Attribute) => {
    const newSorting = sorting.map((sortingElement, i) => {
      if (i !== index) {
        return sortingElement;
      }
      const [, direction] = sortingElement;
      const newElement: SortingElement = [attribute.field, direction];
      return newElement;
    });
    onChange(newSorting);
  };

  const onDirectionChange = (index: number, newDirection: null | SortOrder) => {
    const newSorting = sorting.map((sortingElement, i) => {
      if (i !== index) {
        return sortingElement;
      }
      const [attribute] = sortingElement;
      const newElement: SortingElement = [attribute, newDirection];
      return newElement;
    });
    onChange(newSorting);
  };

  return (
    <Card className={className}>
      <small className={cls.label}>{label}</small>
      <div>
        {sorting.map(([attribute, direction], idx) => (
          <Card className={cls.sortingGroup} key={idx}>
            <Select
              key={[attribute].join(String(idx))}
              small
              minimal
              items={attributes}
              activeItemId={attribute}
              idField="field"
              labelField="label"
              intent={attribute ? Intent.PRIMARY : Intent.NONE}
              filterable={false}
              rightIcon="caret-down"
              placeholder={<span className={cls.sortingPlaceholder}>Attribute...</span>}
              value={attribute}
              onChange={selectedAttribute => {
                onAttributeChange(idx, selectedAttribute);
              }}
            />

            <Select
              key={[direction].join(String(idx))}
              small
              minimal
              items={[
                { field: 'asc', label: 'Ascending', icon: 'sort-asc' },
                { field: 'desc', label: 'Descending', icon: 'sort-desc' },
              ]}
              activeItemId={direction}
              idField="field"
              labelField="label"
              allowNoSelection={false}
              filterable={false}
              rightIcon="caret-down"
              value={direction}
              onChange={selectedDirection => {
                onDirectionChange(idx, selectedDirection.field);
              }}
            />

            <Button small minimal icon="cross" onClick={() => onSortingRemove(idx)} />
          </Card>
        ))}

        <Button
          outlined
          text="Add sorting"
          icon="plus"
          onClick={onSortingAdd}
          disabled={sorting.length === attributes.length || Boolean(sorting.find(([attribute]) => attribute === null))}
        />
      </div>
    </Card>
  );
}
// }
